const actions = {
  /**
   * Find address by zip.
   *
   * @param $http
   * @param zip
   * @returns {Promise<object>}
   */
  async findAddressByZip({ rootState: { $http } }, { zip }) {
    const { data } = await $http.create({ headers: null, timeout: 10 * 1000 })
      .get(`https://viacep.com.br/ws/${zip}/json/`);

    return {
      street: data.logradouro,
      number: '',
      complement: data.complemento,
      district: data.bairro,
      city: data.localidade,
      state: data.uf,
    };
  },
};

export default actions;
